<template>
  <el-row>
    <el-col :span="4">
      <basic-container>
        <el-tree
          class="filter-tree"
          :props="treeProps"
          node-key="id"
          ref="leftTreeRef"
          :load="lazyLoadLeftTree"
          :filter-node-method="filterNode"
          lazy
          @node-click="nodeClick"
          v-loading="loading"
        >
        </el-tree>
      </basic-container>
    </el-col>
    <el-col :span="1" id="parkV4wardSettingsLine">
      <basic-container>
        <el-divider direction="vertical"></el-divider>
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container id="settingForm">
        <el-form ref="matchSettingForm" v-show="showMatchSettingForm" :model="matchSettingForm" label-width="230px"
                 margin-top="20">
          <el-row>
            <el-col :span="10" style="height: 30px;">
              <el-form-item label="开启车牌模糊匹配功能">
                <el-switch
                  v-model="matchSettingForm.plateMatchOpen"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px;margin-top: 7px">开启后车牌识别会使用车牌匹配规则进行匹配</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 30px;">
              <el-form-item label="开启车牌忽略首汉字匹配功能">
                <el-switch
                  v-model="matchSettingForm.ignoreFirstLetter"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px;margin-top: 7px">开启后车牌识别会使用忽略首汉字进行匹配车牌</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 30px;">
              <el-form-item label="忽略首汉字与字母匹配同时使用">
                <el-switch
                  v-model="matchSettingForm.matchPlus"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 30px;">
              <div style="font-size: 10px;margin-top: 7px">开启后会同时忽略首汉字与匹配单个字母同时匹配</div>
            </el-col>
          </el-row>
        </el-form>


        <el-form ref="jobSettingForm" v-show="showJobSettingForm" :model="jobSettingForm" label-width="160px"
                 margin-top="20" :rules="settingRules">
          <el-row style="padding-bottom: 0;margin-bottom: 0">
            <el-col style="margin-top:15px;">
              <strong>图片上传</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10"  style="height: 20px;">
              <el-form-item label="开启图片上传功能">
                <el-switch
                  v-model="jobSettingForm.openImageUpload"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 45px;">
              <div style="font-size: 10px;margin-top: 12px">开启后客户端会定时上传图片</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11"  style="height: 45px;">
              <el-form-item label="图片上传执行cron" prop="imageUploadCron">
                <el-input v-model="jobSettingForm.imageUploadCron"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px;margin-top: 12px;padding-left: 20px">不配置则随机空闲时间执行</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2"  style="height: 30px;">
              <el-form-item label="图片压缩参数:" label-width="140px">
              </el-form-item>
            </el-col>
            <el-col :span="7" offset="2"  style="height: 30px;">
              <el-form-item label="宽度" label-width="70px" prop="imageCompressWidth">
                <el-input type="number" v-model="jobSettingForm.imageCompressWidth"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7"  style="height: 30px;">
              <el-form-item label="高度" label-width="70px" prop="imageCompressHeight">
                <el-input type="number" v-model="jobSettingForm.imageCompressHeight"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col style="margin-top:15px;">
              <strong>更新检查</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10"  style="height: 45px;">
              <el-form-item label="是否立即重启">
                <el-switch
                  v-model="jobSettingForm.autoRestartAfterUpdate"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="14" style="height: 45px;">
              <div style="font-size: 10px;margin-top: 12px">开启后客户端更新完毕立即自动重启</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" style="height: 45px;">
              <el-form-item label="更新检查cron" prop="updateCheckCron">
                <el-input v-model="jobSettingForm.updateCheckCron"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="height: 30px;">
              <div style="font-size: 10px;margin-top: 12px;padding-left: 20px">客户端定时检查版本更新</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>图片处理</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9" style="height: 30px;">
              <el-form-item label="客户端图片保存" prop="imageClearExpireDays">
                <el-input v-model="jobSettingForm.imageClearExpireDays">
                  <template slot="append">天</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" style="height: 30px;">
              <el-form-item label="图片删除cron" prop="imageClearExpireCron">
                <el-input v-model="jobSettingForm.imageClearExpireCron"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>月卡车凭证</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9" style="height: 30px;">
              <el-form-item label="月卡车拉取时间间隔" prop="credentialPullInterval">
                <el-input v-model="jobSettingForm.credentialPullInterval">
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" style="height: 30px;">
              <el-form-item label="月卡车过期检查cron" prop="credentialStatusCheckCron">
                <el-input v-model="jobSettingForm.credentialStatusCheckCron"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>客户端消息重发</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="height: 45px;">
              <el-form-item label="不保存的消息类型" prop="selectedNotSaveTypes">
                <el-select multiple="true" v-model="selectedNotSaveTypes" style="width: 90%;">
                  <el-option
                    v-for="item in messageTypeList"
                    :key="item.dictValue"
                    :label="item.dictKey"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11" style="height: 45px;">
              <el-form-item label="客户端启动后过" prop="messageResendFirstDelay">
                <el-input v-model="jobSettingForm.messageResendFirstDelay">
                  <template slot="append">秒开始检查</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9" style="height: 45px;">
              <el-form-item label="检查时间间隔" prop="messageResendInterval">
                <el-input v-model="jobSettingForm.messageResendInterval">
                  <template slot="append">秒</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="height: 60px;">
              <el-form-item label="失败重发的消息类型" prop="selectedResendTypes">
                <el-select multiple="true" v-model="selectedResendTypes" style="width: 90%;">
                  <el-option
                    v-for="item in messageTypeList"
                    :key="item.dictValue"
                    :label="item.dictKey"
                    :value="item.dictValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>


        <el-form ref="otherSettingForm" v-show="showOtherSettingForm" :model="otherSettingForm" label-width="180px"
                 margin-top="20" :rules="settingRules">
          <el-row>
            <el-col  style="margin-top:15px;">
              <strong>优惠券扫码</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="是否启用服务端计费" prop="serverBilling">
                <el-switch
                  v-model="otherSettingForm.serverBilling"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">默认客户端计费</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="场内缴费允许停留时间" prop="allowStayMinutes">
                <el-input type="number" v-model="otherSettingForm.allowStayMinutes">
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">不配置则默认为15分钟，超过后重新计算停车费</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>识别设置</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="客户端初始安装版本" prop="version">
                <el-input v-model="otherSettingForm.version"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" offset="1" style="height: 35px;">
              <el-form-item label="使用地感信号作为入场标识" prop="useEarthSense" label-width="200px">
                <el-switch
                  v-model="otherSettingForm.useEarthSense"
                  :active-value="switchBoolValue.yes"
                  :inactive-value="switchBoolValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="测试无牌车标识" prop="noPlateCarTag">
                <el-input v-model="otherSettingForm.noPlateCarTag">

                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" offset="1" style="height: 35px;">
              <el-form-item label="车牌重复识别时间" prop="identityDuplicatedTime">
                <el-input v-model="otherSettingForm.identityDuplicatedTime">
                  <template slot="append">秒</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col  :span="10" style="height: 35px;">
              <el-form-item label="启用车位已满判断" prop="useParkFull">
                <el-switch
                  v-model="otherSettingForm.useParkFull"
                  :active-value="switchBoolValue.yes"
                  :inactive-value="switchBoolValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">注意：启用副摄像头务必启用地感信号</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="识别有效时间" prop="recEffectiveMinutes">
                <el-input type="number" v-model="otherSettingForm.recEffectiveMinutes">
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">副摄像头识别该车牌时间距上次多长时间内不处理,默认1分钟</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>一位多车收费模式 (启用后同车主的临停车可以共享月卡车位)</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="是否启用一位多车" prop="useOneSpaceMoreCar">
                <el-switch
                  v-model="otherSettingForm.useOneSpaceMoreCar"
                  :active-value="switchBoolValue.yes"
                  :inactive-value="switchBoolValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">默认不启用</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>启用车位组</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="是否启用车位组" prop="useCarParkGroup">
                <el-switch
                  v-model="otherSettingForm.useCarParkGroup"
                  :active-value="switchBoolValue.yes"
                  :inactive-value="switchBoolValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">默认不启用</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="margin-top:15px;">
              <strong>无感停车设置</strong>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" style="height: 35px;">
              <el-form-item label="是否启用无感停车" prop="useSenselessParking">
                <el-switch
                  v-model="otherSettingForm.useSenselessParking"
                  :active-value="switchBoolValue.yes"
                  :inactive-value="switchBoolValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1" style="height: 35px;">
              <div style="font-size: 10px;margin-top: 12px">默认不启用</div>
            </el-col>
          </el-row>
          <el-row v-if="otherSettingForm.useSenselessParking==switchBoolValue.yes">
            <el-col span="20">
              <el-form-item label="无感支付" prop="senselessParkTypes"  >
                  <el-select style="width:100%;"
                    v-model="otherSettingForm.senselessParkTypes"
                    multiple
                    placeholder="请选择无感支付">
                    <el-option
                      v-for="item in noninductivePayTypeList"
                      :key="item.id"
                      :label="item.dictValue"
                      :value="item.dictKey">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col span="20">
              <el-form-item label="微信支付分限额" prop="wechatScoreLimit"  >
                  <el-input placeholder="请输入 微信支付分限额" maxlength="6" show-word-limit v-model="otherSettingForm.wechatScoreLimit" @input="wechatScoreLimitInput">
                     <template slot="append">元</template>
                  </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <el-form ref="submitForm" label-width="180px" style="margin-top:20px;">
          <el-row>
            <el-col offset="3" style="height: 30px;">
              <el-form-item>
                <el-button
                  v-if="permissionList.saveBtn"
                  :disabled="buttonDisabled"
                  type="primary"
                  size="small"
                  icon="el-icon-check"
                  @click="saveSetting"
                  :loading="submitting"
                >保存
                </el-button
                >
                <el-button
                  :loading="submitting"
                  size="small"
                  v-if="permissionList.syncBtn"
                  @click="syncSetting"
                  icon="el-icon-sort"
                >同步
                </el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
  import {sync, getDetail, update} from "@/api/v4ward/park/car/carv4wardsettings";
  import {getDictionary} from '@/api/common';
  import {mapGetters} from 'vuex';
  import {v4wardMessageTypes,latestVersion} from '@/views/v4ward/car/merge/api/park-merge';
  import {cronValidator} from '@/util/validate'

  export default {
    props: {
      parkSpace: {},
    },
    data() {
      var numberCheck = (rule, value, callback) => {
        if ((typeof value !== 'number' && isNaN(value))) {
          callback(new Error('请输入数字！'));
        } else if (value < rule.min || value > rule.max) {
          callback(new Error('有效数据' + rule.min + '-' + rule.max + '！'));
        } else {
          callback();
        }
      };
      return {
        senselessParkTypes:[],
        noninductivePayTypeList:[],
        treeProps: {
          //标题
          label: 'dictValue',
          //值
          value: 'dictKey',
          //子节点
          children: 'children',
          //是否叶子节点
          isLeaf: 'isLeaf',
        },
        submitting: false,
        paramType: 0,
        showMatchSettingForm: false,
        showJobSettingForm: false,
        showOtherSettingForm: false,
        settings: '',
        click: false,
        messageTypeList: [],
        query: {},
        formData: {},
        matchSettingForm: {
          plateMatchOpen: 0,
          ignoreFirstLetter: 0,
          matchPlus: 0,
        },
        otherSettingForm: {
          allowStayMinutes: 15,
          recEffectiveMinutes: 1,
          serverBilling: 0,
          useParkFull:'false',
          senselessParkTypes:[],
          senselessParkTypes:'',
          // this.formData.senselessParkTypes = this.otherSettingForm.senselessParkTypes:'',
        },
        jobSettingForm: {
          openImageUpload: 0,
          imageUploadCron: '',
          imageCompressWidth: 600,
          imageCompressHeight: 380,
          autoRestartAfterUpdate: 1,
          updateCheckCron: '',
          imageClearExpireDays: 30,
          imageClearExpireCron: '0 0 */8 * * ? *',
          credentialPullInterval: 5,
          credentialStatusCheckCron: '0 0 1 * * ? *',
          messageResendFirstDelay: 10,
          messageResendInterval: 10,
          resendTypes: '',
          notSaveTypes: '',
        },
        latestVersion: 'v1.0.0',
        selectedNotSaveTypes: [],
        selectedResendTypes: [],
        defaultResendMessageTypes: ['PARK_CAR_IN','PARK_CAR_OUT','PARK_TEMPCAR_BILL','PARK_HANDOVER','PARK_UNUSUAL'],
        defaultNotSaveType: ['EQUIPMENT_ON_LINE','PARK_CREDENTIAL'],
        switchValue: {yes: 1, no: 0},
        switchBoolValue: {yes: 'true', no: 'false'},
        settingRules: {
          imageUploadCron: [
            {message: '请输入cron表达式', trigger: 'blur'},
            {message: '请输入cron表达式', trigger: 'change', validator: cronValidator},
          ],
          updateCheckCron: [
            {required: true, message: '请输入cron表达式', trigger: 'blur'},
            {message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator},
          ],
          imageCompressWidth: [
            {required: true, message: '请输入图片宽度', trigger: 'blur'},
            {validator: numberCheck, min: 100, max: 1000, trigger: 'blur'},
          ],
          imageCompressHeight: [
            {required: true, message: '请输入图片高度', trigger: 'blur'},
            {validator: numberCheck, min: 100, max: 1000, trigger: 'blur'},
          ],
          allowStayMinutes: [
            {required: true, message: '请输入停留时间', trigger: 'blur'},
            {validator: numberCheck, min: 5, max: 120, trigger: 'blur'},
          ],
          imageClearExpireDays: [
            {required: true, message: '请输入图片保存时间', trigger: 'blur'},
            {validator: numberCheck, min: 7, max: 120, trigger: 'blur'},
          ],
          imageClearExpireCron: [
            {required: true, message: '请输入cron表达式', trigger: 'blur'},
            {message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator},
          ],
          credentialPullInterval: [
            {required: true, message: '请输入月卡车拉取时间间隔', trigger: 'blur'},
            {validator: numberCheck, min: 5, max: 120, trigger: 'blur'},
          ],
          credentialStatusCheckCron: [
            {required: true, message: '请输入cron表达式', trigger: 'blur'},
            {message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator},
          ],
          messageResendFirstDelay: [
            {required: true, message: '请输入时间间隔', trigger: 'blur'},
            {validator: numberCheck, min: 5, max: 60, trigger: 'blur'},
          ],
          senselessParkTypes:[

            {required: true, message: '请选择无感支付', trigger: 'change'},
          ],
          version: [
            {required: true, message: '请输入版本号', trigger: 'blur'},
          ],
/*          selectedNotSaveTypes: [
            {required: true, message: '请选择无需保存的消息类型', trigger: 'blur'},
          ],
          selectedResendTypes: [
            {required: true, message: '请选择发送失败后需要重发的消息类型', trigger: 'blur'},
          ],*/
          noPlateCarTag: [
            {required: true, min: 2, max: 7, message: '请输入无牌车标记', trigger: 'blur'},
          ],
          messageResendInterval: [
            {required: true, message: '请输入时间间隔', trigger: 'blur'},
            {validator: numberCheck, min: 10, max: 60, trigger: 'blur'},
          ],
          identityDuplicatedTime: [
            {required: true, message: '请输入车牌识别间隔时间', trigger: 'blur'},
            {validator: numberCheck, min: 30, max: 300, trigger: 'blur'},
          ],
          recEffectiveMinutes: [
            {required: true, message: '请输入识别有效时间', trigger: 'blur'},
            {validator: numberCheck, min: 1, max: 5, trigger: 'blur'},
          ],
        },
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          saveBtn: this.vaildData(this.permission.carv4wardsettings_save, true),
          syncBtn: this.vaildData(this.permission.carv4wardsettings_sync, true)
        };
      },
    },

    created() {
      this.initMessageTypeList();
    },

    methods: {
      initMessageTypeList(){
        v4wardMessageTypes().then((res) =>{
          this.messageTypeList = res.data;
        });
        latestVersion().then((res) =>{
          this.latestVersion = res.data.releaseVersion;
        });
        getDictionary('noninductive-pay-type').then(res=>{
          this.noninductivePayTypeList = res.data;
          if(!this.otherSettingForm.senselessParkTypes){
            res.data.forEach(ele=>{
              this.senselessParkTypes.push(ele.dictKey);
            })
          }


        })
      },
      wechatScoreLimitInput(e){
        this.otherSettingForm.wechatScoreLimit = this.outNumber(e);
      },
      outNumber(e,max=800){
              let value = e;
              value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
              value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
              value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
              value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
              if (value.indexOf(".") < 0 && value != "") {
                      //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
                      value = parseFloat(value);
              }
              if(value > max){
                      value = max
              }
              if(value=='.'){
                      value = '0.'
              }

              return value;
      },

      // 切换无感支付方式
      noninductivePayTypeChange(e){
        if(e[0]){
          this.otherSettingForm.senselessParkTypes = e.join(',');
          console.log(this.otherSettingForm.senselessParkTypes)
        }else{
          this.otherSettingForm.senselessParkTypes = '';
        }
        console.log(this.otherSettingForm)

      },
      refreshShowForm() {
        this.showMatchSettingForm = this.paramType === 1;
        this.showJobSettingForm = this.paramType === 2;
        this.showOtherSettingForm = this.paramType === 9;
      },
      //加载树
      lazyLoadLeftTree(node, resolve) {
        if (this.click) {
          return;
        }
        getDictionary('park_param_type').then((data) => {
          if (data.data.length > 0) {
            this.paramType = parseInt(data.data[0].dictKey);
          }
          data.data.forEach(type => {
            type.isLeaf = true;
            type.children = null;
          });
          resolve(data.data);
          this.onLoad();
        });
        this.click = true;
      },
      //树节点过滤
      filterNode(value, data) {
        return true;
      },
      //点击左侧树结构回调
      nodeClick(data) {
        var intDictKey = parseInt(data.dictKey);
        if (this.paramType === intDictKey) {
          return;
        }
        this.paramType = intDictKey;
        this.onLoad();
      },
      onLoad() {
        if (parseInt(this.paramType) === 0) {
          return;
        }
        this.refreshShowForm();
        getDetail({'parkingLotId': this.parkSpace.id, 'paramType': this.paramType}).then(({data}) => {
          this.formData = data;
          if (this.vdui.isNotEmpty(data.settings)) {
            if (this.paramType === 1) {
              this.matchSettingForm = JSON.parse(data.settings);
            } else if (this.paramType === 2) {
              this.jobSettingForm = JSON.parse(data.settings);
              if(this.vdui.isEmpty(this.jobSettingForm)){
                this.jobSettingForm = this.defaultJobSettingForm();
              }

              if (this.vdui.isEmpty(this.jobSettingForm.updateCheckCron)) {
                this.jobSettingForm.updateCheckCron = this.randomCron();
                this.jobSettingForm.autoRestartAfterUpdate = 1;
              }
              if (this.vdui.isEmpty(this.jobSettingForm.imageUploadCron)) {
                this.jobSettingForm.imageUploadCron = this.randomCron();
              }
              if(this.vdui.isEmpty(this.jobSettingForm.notSaveTypes)){
                this.selectedNotSaveTypes = this.defaultNotSaveType;
              }else {
                this.selectedNotSaveTypes = this.jobSettingForm.notSaveTypes.split(',');
              }
              if(this.vdui.isEmpty(this.jobSettingForm.resendTypes)){
                this.selectedResendTypes = this.defaultResendMessageTypes;
              }else {
                this.selectedResendTypes = this.jobSettingForm.resendTypes.split(',');
              }
              if (this.vdui.isEmpty(this.jobSettingForm.credentialStatusCheckCron)) {
                this.jobSettingForm.credentialStatusCheckCron = this.randomCron();
              }
              if (this.vdui.isEmpty(this.jobSettingForm.imageClearExpireCron)) {
                this.jobSettingForm.imageClearExpireCron = this.randomCron();
              }
            } else if (this.paramType === 9) {
              this.otherSettingForm = JSON.parse(data.settings);
              if(this.vdui.isEmpty(this.otherSettingForm)){
                this.otherSettingForm = this.defaultOtherSettingForm();
              }
            }

          } else {
            this.matchSettingForm = {
              plateMatchOpen: 0,
              ignoreFirstLetter: 0,
              matchPlus: 0,
            };
            this.jobSettingForm = this.defaultJobSettingForm();
            this.otherSettingForm = this.defaultOtherSettingForm();
          }
        });
      },
      defaultOtherSettingForm(){
        return {
          allowStayMinutes: 15,
          recEffectiveMinutes: 1,
          useParkFull:'false',
          serverBilling: 0,
          noPlateCarTag: '12345',
          identityDuplicatedTime: 60,
          useEarthSense: 'false',
          useOneSpaceMoreCar: 'false',
          useCarParkGroup:'false',
          useSenselessParking: 'false',
          version: this.latestVersion,
        };
      },
      defaultJobSettingForm(){
        this.selectedNotSaveTypes =  this.defaultNotSaveType;
        this.selectedResendTypes =  this.defaultResendMessageTypes;
        return {
          openImageUpload: 0,
          imageUploadCron: this.randomCron(),
          imageCompressWidth: 600,
          imageCompressHeight: 380,
          autoRestartAfterUpdate: 1,
          updateCheckCron: this.randomCron(),
          imageClearExpireDays: 30,
          imageClearExpireCron: '0 0 */8 * * ? *',
          credentialPullInterval: 5,
          credentialStatusCheckCron: '0 0 1 * * ? *',
          messageResendFirstDelay: 10,
          messageResendInterval: 10,
          resendTypes: this.defaultResendMessageTypes.join(','),
          notSaveTypes: this.defaultNotSaveType.join(','),
        };
      },

      saveSetting() {
        var submitForm = this.setParam();
        if (submitForm == null) {
          return;
        }
        console.log(this.formData)
        submitForm.validate((valid) => {
          if (valid) {
            this.submitting = true;
            //其它参数用新的form
            update(this.formData).then((res) => {
              this.submitting = false;
              this.$message.success('修改成功!');
            }).catch(err => {
              this.submitting = false;
            });
          }
        });
      },
      syncSetting() {
        var submitForm = this.setParam();
        if (submitForm == null) {
          return;
        }
        submitForm.validate((valid) => {
          if (valid) {
            this.submitting = true;
            //其它参数用新的form
            sync(this.formData).then((res) => {
              this.$message.success('同步成功!');
              this.submitting = false;
            }).catch(err => {
              this.submitting = false;
            });
          }
        });
      },
      setParam() {
        if (this.paramType === 1) {
          this.formData.settings = JSON.stringify(this.matchSettingForm);
          this.formData.remark = '系统配置-模糊匹配设置';
          return this.$refs.matchSettingForm;
        } else if (this.paramType === 2) {
          this.jobSettingForm.notSaveTypes = this.selectedNotSaveTypes.join(',');
          this.jobSettingForm.resendTypes = this.selectedResendTypes.join(',');
          this.formData.settings = JSON.stringify(this.jobSettingForm);
          this.formData.remark = '系统配置-定时任务设置';
          return this.$refs.jobSettingForm;
        } else if (this.paramType === 9) {

          if(this.vdui.isNotEmpty(this.otherSettingForm.useParkFull) && this.otherSettingForm.useParkFull === "true"){
            //启用车位已满逻辑，地感信号启用
            this.otherSettingForm.useEarthSense = "true";
          }
          this.formData.settings = JSON.stringify(this.otherSettingForm);
          this.formData.remark = '系统配置-其它配置';
          return this.$refs.otherSettingForm;
        }
        return null;
      },
      randomCron() {
        var cron = "";
        cron = cron + Math.ceil(Math.random() * 60) + " ";
        cron = cron + Math.ceil(Math.random() * 60) + " ";
        cron = cron + Math.ceil(Math.random() * 7) + " * * ? *";
        return cron;
      }
    }
  };
</script>

<style scoped>
  #parkV4wardSettingsLine .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 10em;
    margin: 0 1px;
    vertical-align: middle;
    position: relative;
  }

  #parkV4wardSettingsLine .el-card__body {
    padding: 1px !important;
  }

  #settingForm .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  #settingForm .el-form-item__content .el-input-group {
    vertical-align: middle;
  }

  #settingForm .el-input-group__append, .el-input-group__prepend {
    padding: 0 5px;
  }
</style>
